import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TbLogin } from "react-icons/tb";
import { BiSupport } from "react-icons/bi";
import { MdOutlineInfo, MdHome, MdAccountCircle, MdOutlineEventAvailable, MdSchool } from 'react-icons/md'; // MdSchool for Student Explore icon
import SignOut from '../SignOut';
import LoginRegister from '../../Login/login';
import ContactSupportModal from '../../contactsupport/ContactSupportModal';

const SideMenu = ({ isVisible, toggleSideMenu }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isContactModalVisible, setIsContactModalVisible] = useState(false);
  const [initialTab, setInitialTab] = useState('user');
  const [hidePersonalAccount, setHidePersonalAccount] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('google_token');
    if (token) setIsAuthenticated(true);
  }, []);

  const toggleModal = (tab = 'user', hidePersonal = false) => {
    setInitialTab(tab);
    setHidePersonalAccount(hidePersonal);
    setIsModalVisible(!isModalVisible);
  };

  const handleSignOutCallback = () => {
    setIsAuthenticated(false);
    toggleSideMenu();
  };

  return (
    <>
      {/* Side Menu */}
      <div
        className={`fixed top-0 right-0 h-full transform ${
          isVisible ? 'translate-x-0' : 'translate-x-full'
        } transition-transform duration-500 ease-in-out w-64 bg-white shadow-lg z-30 rounded-l-lg`}
      >
        <div className="flex flex-col h-full p-4 text-gray-800 space-y-3">
          {/* Header */}
          <div className="flex items-center justify-center mb-4">
            <Link 
              to="/explore" 
              onClick={toggleSideMenu}
              className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 text-xl md:text-2xl font-bold hover:text-indigo-600 transition-colors duration-300"
            >
              BookurSpot
            </Link>
          </div>

          {/* User Welcome (If Authenticated) */}
          {isAuthenticated && (
            <div className="text-sm text-gray-800 mb-4">
              Welcome back, User!
            </div>
          )}

          {/* Menu Items */}
          <div className="flex-grow">
            <ul className="space-y-2">
              <li className="flex items-center text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md p-2">
                <MdHome className="mr-3 text-xl text-indigo-500" />
                <Link to="/bookings" onClick={toggleSideMenu} className="flex-grow text-left">Home</Link>
              </li>
              <li className="flex items-center text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md p-2">
                <MdOutlineEventAvailable className="mr-3 text-xl text-indigo-500" />
                <Link to={isAuthenticated ? "/mybookings" : "/viewbookings"} onClick={toggleSideMenu} className="flex-grow text-left">
                  {isAuthenticated ? "My Bookings" : "View Bookings"}
                </Link>
              </li>
              <li className="flex items-center text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md p-2">
                <MdSchool className="mr-3 text-xl text-indigo-500" />
                <Link to="/student/explore" onClick={toggleSideMenu} className="flex-grow text-left">
                  Student Explore
                </Link>
              </li>
              {isAuthenticated && (
                <li className="flex items-center text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md p-2">
                  <MdAccountCircle className="mr-3 text-xl text-indigo-500" />
                  <Link to="/profile" onClick={toggleSideMenu} className="flex-grow text-left">Profile</Link>
                </li>
              )}
              {!isAuthenticated && (
                <li className="flex items-center text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md p-2">
                  <TbLogin className="mr-3 text-xl text-indigo-500" />
                  <button
                    onClick={() => {
                      toggleSideMenu();
                      toggleModal('user', false);
                    }}
                    className="flex-grow text-left"
                  >
                    Sign In
                  </button>
                </li>
              )}
            </ul>
          </div>

          {/* Bottom Links */}
          <div className="border-t border-gray-200 pt-4">
            <ul className="space-y-2">
              <li className="flex items-center text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md p-2">
                <MdOutlineInfo className="mr-3 text-xl text-indigo-500" />
                <Link to="/" onClick={toggleSideMenu} className="flex-grow text-left">About</Link>
              </li>
              <li className="flex items-center text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md p-2">
                <BiSupport className="mr-3 text-xl text-indigo-500" />
                <button
                  onClick={() => {
                    toggleSideMenu();
                    setIsContactModalVisible(true);
                  }}
                  className="flex-grow text-left"
                >
                  Contact Support
                </button>
              </li>
              {isAuthenticated ? (
                <li className="flex items-center text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md p-2">
                  <SignOut onSignOut={handleSignOutCallback} />
                </li>
              ) : (
                <li className="flex items-center text-gray-800 bg-gray-100 hover:bg-gray-200 rounded-md p-2">
                  <TbLogin className="mr-3 text-xl text-indigo-500" />
                  <Link
                    to="/ClientLogin"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleSideMenu();
                      toggleModal('business', true);
                    }}
                    className="flex-grow text-left"
                  >
                    Partner Sign In
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-20" onClick={toggleSideMenu}></div>
      )}

      {/* Modals */}
      {isModalVisible && (
        <LoginRegister
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          initialTab={initialTab}
          hidePersonalAccount={hidePersonalAccount}
        />
      )}
      <ContactSupportModal
        isVisible={isContactModalVisible}
        onClose={() => setIsContactModalVisible(false)}
      />
    </>
  );
};

export default SideMenu;
